<template>
  <div class="c-about">
    <h1>Hi! I'm Michael :)</h1>
    <div class="o-layout c-intro">
      <div class="o-layout__item u-1/1 u-1/2@sm">
        <div>
          <div class="u-text--xlarge">
            I'm a User Experience/Product Designer with over 10 years of experience working in complex, technical
            domains
            such as industrial machinery and medical devices.
          </div>
          <div class="u-text--xlarge">My superpower is working with expert users with deep domain knowledge.</div>
        </div>
      </div>
      <div class="o-layout__item u-1/1 u-1/2@sm c-callout c-callout__center-align">
        <img src="images/about/portrait-nu.jpg" />
        <div class="c-caption">Hello!</div>
      </div>
    </div>

    <div class="c-bio">
      <p>
        I have conducted research and design in a radiation oncology cancer center, airplane jet
        engine repair shop, locomotive cab, power utility control room, wind farm with a prototype
        wind turbine, and flow battery startup, among others.
      </p>
      <p>My favorite design joke:</p>
      <p>
        Q: How many designers does it take to screw in a lightbulb?
        <br />
        A: Does it have to be a lightbulb?
      </p>
      <p>
        <a href="https://www.linkedin.com/in/michaelcohnmoreau/" target="_blank">
          Find me on LinkedIn
        </a>
      </p>
    </div>

    <div class="c-block">
      <hr class="c-block" />
      <h3>What I Do for Fun</h3>

      <div class="o-layout">
        <div class="o-layout__item u-1/1 u-1/3@sm">
          <h4>I Knit!</h4>
          <div class="o-caption">
            <img src="images/about/knit_small.jpg" />
            <div class="c-caption c-caption__gallery">
              I made this hat for a fundraiser for the Leukemia and Lymphoma Society.
            </div>
          </div>
        </div>

        <div class="o-layout__item u-1/1 u-1/3@sm">
          <h4>I Make and Print Models!</h4>
          <div class="o-caption">
            <img src="images/about/pumperkin.jpg" />
            <div class="c-caption c-caption__gallery">
              One of my first attempts at organic shapes in Blender. It holds a tealight (^_^)
            </div>
          </div>
        </div>

        <div class="o-layout__item u-1/1 u-1/3@sm">
          <h4>I Draw!</h4>
          <div class="o-caption">
            <img src="images/about/pigxie_small.jpg" />
            <div class="c-caption c-caption__gallery">
              It’s a Pigxie ... get it? Drawn in pencil and colored in Procreate.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use '../assets/scss/_mixins.scss';

.c-about {
  img {
    @include mixins.pop;
  }
}

.c-intro {
  max-width: 860px;
  margin: 0 auto;
  margin-bottom: mixins.$padding-regular;

  h2 {
    line-height: 1.3333;
  }

  p {
    padding-bottom: 1rem;
  }

  .o-layout__item {
    padding-left: 0;
    padding-right: 20px;
  }
}

.c-bio {
  max-width: 860px;
  margin-left: auto;
  margin-right: auto;
}
</style>
